import React, { FC, ReactNode } from 'react'
import { Typography } from 'transfix-ui/core'
import { MAIN_HELP_PHONE } from 'apps/fleet-planner/constants'
import { TEAM_MEMBER_USER_TYPES } from 'apps/fleet-planner/types'
import { ConfirmationModal } from 'transfix-ui'
import formatPhone from 'utils/formatPhone'

export type TActionType = 'book' | 'bid'

const userTypesByKey = {
  [TEAM_MEMBER_USER_TYPES.DISPATCHER]: 'Dispatcher',
  [TEAM_MEMBER_USER_TYPES.DRIVER]: 'Driver',
  [TEAM_MEMBER_USER_TYPES.OWNER_OPERATOR]: 'Owner Operator Employee',
}

const actionTypesByKey: Record<TActionType, string> = {
  book: 'sign rate confirmations',
  bid: 'submit bids',
}

const getCopyByUserType = (
  userType?: TEAM_MEMBER_USER_TYPES,
  actionType?: TActionType,
  opsRep?: {
    phone: string
  }
): ReactNode => {
  if (!userType || !actionType) return <></>
  const formattedUserType = userTypesByKey[userType]
  const formattedActionType = actionTypesByKey[actionType]

  // If no operations phone number is available, use the main phone line
  const { phone = MAIN_HELP_PHONE } = opsRep || {}

  return (
    <Typography variant='body2' component='div'>
      You have a <strong>{formattedUserType}</strong> account, which means your carrier has not
      granted you the ability to {formattedActionType}. If this is incorrect, please call our
      Operations team at {formatPhone(phone)} and we will assist you.
    </Typography>
  )
}

interface IBiddingPermissionsModalProps {
  onClose: () => void
  isOpen: boolean
  userType?: TEAM_MEMBER_USER_TYPES
  actionType?: TActionType
  opsRep?: {
    phone: string
  }
}

/**
 * Displayed when a user is attempting to book or bid on a load.
 * If the user is not a Dispatcher, we show this modal.
 */
export const BiddingPermissionsModal: FC<IBiddingPermissionsModalProps> = ({
  actionType,
  isOpen,
  onClose,
  opsRep,
  userType,
}) => {
  const copy = getCopyByUserType(userType, actionType, opsRep)
  return (
    <ConfirmationModal
      title={`You need permission to ${actionType}`}
      size={4}
      open={isOpen}
      actions={[
        {
          label: 'Close',
          type: 'confirm',
          action: onClose,
        },
      ]}
      onClose={onClose}>
      {copy}
    </ConfirmationModal>
  )
}
